export function filterOperatorLabel(isNegated: boolean, valueCount = 1) {
	if (isNegated) return valueCount > 1 ? "is none of" : "is not"
	return valueCount > 1 ? "is any of" : "is"
}

export function withoutNegation<T extends string>(
	negations: Partial<Record<T, boolean>>,
	key: T,
): Partial<Record<T, boolean>> {
	if (negations[key] === undefined) return negations
	const next = { ...negations }
	delete next[key]
	return next
}

/**
 * The operator only means something while values are selected. Emptying a
 * filter one value at a time has to drop it too, or the next value the user
 * picks silently reads "is not".
 */
export function negationsAfterRemoval<T extends string>(
	negations: Partial<Record<T, boolean>>,
	key: T,
	remaining: readonly unknown[],
): Partial<Record<T, boolean>> {
	return remaining.length === 0 ? withoutNegation(negations, key) : negations
}
